export function validateAdministratorName(value: string) {
  let error
  if (!value) {
    error = 'NAME_REQUIRED'
  }
  return error
}
